// extracted by mini-css-extract-plugin
module.exports = {"seo":"SeoHeader-module--seo--38wSg","human":"SeoHeader-module--human--1Dce0"};